import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const TypeOfBody = (props) => {
  return (
    <FormGroup controlId="typeOfBody">
      <Col componentClass={ControlLabel} sm={5}>
        Type of Body
      </Col>
      <Col sm={7}>
          <FormControl type="text" value={props.typeOfBody} onChange={props.handleChangeTypeOfBody}
            autoComplete="off" />
      </Col>
    </FormGroup>
  )
}

TypeOfBody.propTypes = {
  typeOfBody: PropTypes.string,
  handleChangeTypeOfBody: PropTypes.func
};

export default TypeOfBody;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/typeOfBody/TypeOfBody.js